import { render } from "./calendar.vue?vue&type=template&id=7486c216&lang=pug"
import script from "./calendar.vue?vue&type=script&setup=true&lang=js"
export * from "./calendar.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__